<template>
  <div class="topic">
    <div class="leftlist">
      <van-cell-group>
        <van-cell v-for="item in list" :key="'list_' + item.id" @click="ClickTree(item.id)" :class="item.id==active?'active':''">
          <template slot="title">
            <span class="borderleft"></span>
            <span class="custom-title">{{item.name}}</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <div class="rightlist">
      <van-list
      v-model="loading"
      :finished="finished"
      finished-text="已加载全部"
      @load="onLoad"
      >
      <div slot="loading" class="list-loading">
        <img :src="img.loading" />
      </div>
      <div v-for="itemd in topiclist" :key="'listd_' + itemd.id">
        <van-row class="topicdism" @click="choiseTopic(itemd.id,itemd.name)" v-if="itemd.is_official==0">
          <van-col span="4">
            <img class="listhand" :src="itemd.pic_url">
          </van-col>
          <van-col class="ml-10" span="18">
            <div class="membername">#{{itemd.name}}#</div>
          <!-- <div class="sourtime">
            讨论{{itemd.join_num}}
          </div> -->
        </van-col>
      </van-row>
      </div>
      </van-list>
      <div class="btn-bott">
        <van-button color="#605C6B" size="large" :to="{name: 'LexusCreateTopic'}">创建话题</van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import post from '../../../api/lexus/release';
  import content from '../../../api/content';
  import common from '../../../api/common';
  import { Row,Col,List,Button,Cell, CellGroup,NavBar  } from 'vant';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        top_margin:0,
        brand_id:1,
        params:{
          media_id: 6,
          category_id:0,
          page:1,
          size:10
        },
        active: 0,
        list:[{
          id:0,
          name:'话题推荐'
        }],
        topiclist:[],
        loading: false,
        finished: false,
        img:{
          loading: require('../../../assets/img/loading_lexus.gif')
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          this.$appService.needLogin()
        }
      })
      this.getCategories()
      this.h = document.documentElement.clientHeight || document.body.clientHeight;
      var params={
        event_code: '选择话题',
        event_id:'',
        title: '',
        value: '',
        path: '/Lexus/Release/Topic.vue',
        user_id: this.user_id ? this.user_id : 0,
        source: this.source
      }
      common.BurialPoint(params).then(res => {
        if(res.data.state==1){
        }
      })
      var apppar={
        title:this.$route.meta.title
      }
      this.$appService.changeTitle(apppar)
    },
    activated () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.getCategories()
      this.h = document.documentElement.clientHeight || document.body.clientHeight;
    },
    methods: {
      getCategories(){
        post.getCategories(this.brand_id).then(res => {
          if(res.data.state == 1) {
            this.list.push.apply(this.list, res.data.data)
          }
        })
      },
      ClickTree(id){
        this.active=id
        this.params.category_id=id
        this.params.page=1
        this.topiclist=[]
        this.finished=false
      },
      choiseTopic(id,name){
        var params={
          idlist:[id],
          namelist:[name],
          type:1
        }
        this.$appService.choiseType(params)
      },
      onLoad(){
        content.getTopicList(this.params).then(res => {
          if(res.data.state == 1) {
            this.topiclist.push.apply(this.topiclist, res.data.data.data)
            this.params.page += 1
            this.total = res.data.data.total
            this.loading = false
            if(res.data.data.data.length == 0) {
              this.finished = true
            }
          }
        })
      }
    },
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [CellGroup.name]: CellGroup,
      [Cell.name]:Cell,
      [Button.name]:Button,
      [NavBar.name]:NavBar
    }
  }
</script>

<style lang="scss">
  .topic{
    .leftlist{
      width: 30%;
      float: left;
      background-color: #f8f8f8;
      position: fixed;
      height: 100%;
      overflow-y: auto;
      .van-cell-group{
        background-color: #f8f8f8;
        .active{
          background-color: #fff !important;
          color: #3a3a3a !important;
          .borderleft{
            border-left: 2px solid #3a3a3a;
          }
          .custom-title{
            font-size: 12px;
            margin-left: 18px !important;
          }
        }
        .van-cell{
          padding: 12px 0;
          background-color: #f8f8f8;
          color: #9a9a9a;
          font-size: 12px;
          .custom-title{
            margin-left: 20px;
          }
        }
      }
      .van-cell:not(:last-child)::after{
        border-bottom:none;
      }
      .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
        border-width:0;
      }
    }
    .rightlist{
      width: 65%;
      left: 35%;
      position: absolute;
      margin-bottom: 60px;
      .ml-10{
        margin-left: 10px;
      }
      .topicdism{
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        display: flex;
      }
    }
    .van-row{
      margin-top: 20px;
    }
    .btn-bott{
      position: fixed;
      bottom: 10px;
      width: 60%;
    }
    .van-button{
      height: 40px;
      line-height: 2;
      font-size: 12px;
    }
    .listhand{
      width:40px;
      height:40px;
      object-fit: cover;
    }
    .membername{
      font-size: 14px;
      color: #3A3A3A;
    }
    .sourtime{
      font-size: 12px;
      color: #9A9A9A;
      margin-top: 5px;
    }
  }
</style>
